import React from 'react';

const MediaGalleryPagination = ({
  totalSlides,
  currentSlide,
  visibleRange,
  handleClick,
  hasGroupedDots
}) => {
  const calculateDotSize = (index) => {
    const distance = Math.abs(currentSlide - index);
    if (distance === 0) return hasGroupedDots ? 60 : 30; // Active dot size
    return Math.max(2, 12 - distance); // Decrease size by 1px per step, with a minimum size of 2px
  };

  return (
    <div className="pagination">
      {Array.from(
        { length: hasGroupedDots ? totalSlides - 2 : totalSlides },
        (_, index) =>
          index >= visibleRange[0] &&
          index <= visibleRange[1] && (
            <button
              key={index}
              className={`pagination-dot ${
                currentSlide === index ? 'active' : ''
              }`}
              style={{
                width: `${calculateDotSize(index)}px`,
                height: `${calculateDotSize(index)}px`,
              }}
              onClick={() => handleClick(index)}
            ></button>
          )
      )}
    </div>
  );
};

export default MediaGalleryPagination;
